import React from "react"
import { EditorialLabel } from "../../../features/contents"
import { useLabels } from "../../../features/contents/hooks"
import OrderDetailsPanel from "../../../features/orders/components/OrderDetailsPanel"
import CustomButton from "../../../ui/atoms/Button"
import CustomTextInput from "../../../ui/atoms/CustomTextInput"
import CustomPaper from "../../../ui/molecules/CustomPaper"
import { CustomBox, CustomContainer } from "../../../ui/spacings"
import { getQueryParam } from "../../../utils/url"

const OrderDetailsContainer = () => {
  const { getLabel } = useLabels()
  const [initialized, setInitialized] = React.useState(false)
  const [urlOrderId, setUrlOrderId] = React.useState<string>()
  const [orderId, setOrderId] = React.useState<string>("")
  const [inputOrderId, setInputOrderId] = React.useState<string>()

  React.useEffect(() => {
    if (getQueryParam(window.location, "o")) {
      setUrlOrderId(getQueryParam(window.location, "o"))
    }
    setInitialized(true)
  }, [])

  const handleSearch = () => {
    if (!orderId) {
      return
    }

    setInputOrderId(orderId.trim())
  }

  return (
    <CustomBox background="disabled" flex="col" flexFill alignItems="center">
      <CustomContainer className="sm:my-24">
        {initialized && !urlOrderId && (
          <CustomPaper className="mx-auto my-4 sm:w-1/2">
            <EditorialLabel scope="order" id="search-order-input-title" />
            <div className="flex flex-col mt-4 sm:flex-row">
              <CustomTextInput
                label={getLabel("order", "search-order-input-label")}
                value={orderId}
                onChange={setOrderId}
                fullWidth
              />
              <CustomButton
                onClick={handleSearch}
                className="w-full mt-4 sm:w-auto sm:mt-0"
              >
                <EditorialLabel scope="common" id="search" plainText />
              </CustomButton>
            </div>
          </CustomPaper>
        )}
        <OrderDetailsPanel orderId={urlOrderId ?? inputOrderId} />
      </CustomContainer>
    </CustomBox>
  )
}

export default OrderDetailsContainer
